import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Spin } from 'antd';
import { Grid } from '../siteList.styles';
import SiteCard from './SiteCard';
const SiteList = memo(({ sites, loading, onSiteClick }) => {
    if (loading) {
        return (_jsx("div", { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }, children: _jsx(Spin, { size: "large" }) }));
    }
    return (_jsx(Grid, { children: sites.map((site) => (_jsx(SiteCard, { site: site, onClick: onSiteClick }, site.siteId))) }));
});
SiteList.displayName = 'SiteList';
export default SiteList;
